export default __webpack_public_path__ + "static/media/tim_read.d352343d.jpg";